import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import "./ErrorAPIConnection.scss";
import Logo from "components/main/Header/Logo";

const ErrorAPIConnection = ({ errorMessage }) => {
  if (!errorMessage) return null;

  return (
    <div className="error-container">
      <div className="error-logo">
        <Logo />
      </div>
      <div className="error-message">
        {errorMessage}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  errorMessage: state.app.error,
});

ErrorAPIConnection.propTypes = {
  errorMessage: PropTypes.string,
};

export default connect(mapStateToProps)(ErrorAPIConnection);
